import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, enableProdMode } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TrackJsErrorHandler } from '../error-handlers/trackjs-error-handler';
import { Ng2UiAuthModule } from 'ng2-ui-auth';
import { AsyncLocalStorageModule } from 'angular-async-local-storage';
import { QRScanner } from '@ionic-native/qr-scanner';
import { ENV } from '../environments/environment';

// Auth & API Services
import { HttpRequestInterceptor } from '../interceptors/http-request-interceptor';
import { AuthenticationApi } from '../services/authentication/authentication-api';
import { CustomersService } from '../services/customers/customers-service';
import { UsersService } from '../services/users/users-service';
import { ProfilesService } from '../services/users/profiles-service';
import { SubscriptionsService } from '../services/subscriptions/subscriptions-service';


// Entrance Page & Supporting App Pages.
import { AtlasApp } from './app.component';
import { LoginPageModule } from '../pages/login/login.module';
import { ForgotPasswordPageModule } from '../pages/forgot-password/forgot-password.module';
import { ResetPasswordPageModule } from '../pages/reset-password/reset-password.module';

import { ScannerPageModule } from '../pages/scanner/scanner.module';
import { NewAccountPageModule } from '../pages/new-account/new-account.module';

import { CustomersPageModule } from '../pages/customers/customers.module';
import { CustomerTabsPageModule } from '../pages/customer-tabs/customer-tabs.module';
import { CustomerOverviewPageModule } from '../pages/customer-overview/customer-overview.module';
import { CustomerDetailPageModule } from '../pages/customer-detail/customer-detail.module';
import { CustomerVehiclePageModule } from '../pages/customer-vehicle/customer-vehicle.module';
import { CustomerBillingPageModule } from '../pages/customer-billing/customer-billing.module';
import { AdminTabsPageModule } from '../pages/admin-tabs/admin-tabs.module';
import { AdminUsersPageModule } from '../pages/admin-users/admin-users.module';
import { QrGeneratorModalPageModule } from '../pages/qr-generator-modal/qr-generator-modal.module';
import { EditUserModalPageModule } from '../pages/edit-user-modal/edit-user-modal.module';
import { CreateUserModalPageModule } from '../pages/create-user-modal/create-user-modal.module';
import { PricingPageModule } from '../pages/pricing/pricing.module';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

// validators
import { CustomerEmailExistsValidator } from '../validators/customer-email-exists';
import { CustomerLicensePlateExistsValidator } from '../validators/customer-license-plate-exists';
import { UserEmailExistsValidator } from '../validators/user-email-exists';


// Set env. mode.
try {
  if(String(ENV.mode).trim().toLowerCase() === "production")
  {
    enableProdMode();
  }
  else
  {
    console.log(`Env: [${ENV.mode}]`);
  }
}
catch(ex) {
  console.log("FATAL ERROR - FAILED TO DETERMINE ENVIRONMENT.",ex);
}

@NgModule({
  declarations: [
    // Main App.
    AtlasApp,

    // Application Pages (States)
    //ScannerPage,
    //CustomersPage,
    //LoginPage,
    //NewAccountPage,
    //CustomerTabsPage,
    //CustomerOverviewPage,
    //CustomerDetailPage,
    //CustomerVehiclePage,
    //CustomerBillingPage,
    //QrGeneratorModalPage,
    //EditUserModalPage,
    //CreateUserModalPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(AtlasApp),
    Ng2UiAuthModule.forRoot({
      tokenName: 'accessToken',
      tokenPrefix: '',
      baseUrl: ENV.apiUrl,
      loginUrl: '/oauth/token'
    }),
    AsyncLocalStorageModule,

    LoginPageModule,
    ForgotPasswordPageModule,
    ResetPasswordPageModule,

    NewAccountPageModule,
    ScannerPageModule,

    CustomersPageModule,
    CustomerTabsPageModule,
    CustomerOverviewPageModule,
    CustomerDetailPageModule,
    CustomerVehiclePageModule,
    CustomerBillingPageModule,
    AdminTabsPageModule,
    AdminUsersPageModule,
    QrGeneratorModalPageModule,
    EditUserModalPageModule,
    CreateUserModalPageModule,
    PricingPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    AtlasApp,
    //ScannerPage,
    //CustomersPage,
    //LoginPage,
    //NewAccountPage,
    //CustomerTabsPage,
    //CustomerOverviewPage,
    //CustomerDetailPage,
    //CustomerVehiclePage,
    //CustomerBillingPage,
    //QrGeneratorModalPage,
    //EditUserModalPage,
    //CreateUserModalPage
  ],
  providers: [
    // Services
    StatusBar,
    //TemplateRef,
    SplashScreen,
    IonicErrorHandler,
    AuthenticationApi,
    CustomersService,
    SubscriptionsService,
    CustomerEmailExistsValidator,
    CustomerLicensePlateExistsValidator,
    UserEmailExistsValidator,
    QRScanner,
    UsersService,
    ProfilesService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    { provide: ErrorHandler,
      useClass: TrackJsErrorHandler
    }
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts